export const ID_TOKEN_COOKIE = 'googleIdToken';
export const ID_TOKEN_EXPIRY_COOKIE = 'googleIdTokenExpiry';
export const ACCESS_TOKEN_COOKIE = 'googleAccessToken';
export const ACCESS_TOKEN_EXPIRY_COOKIE = 'googleAccessTokenExpiry';
